import { useDocumentTitle } from '../../hooks/useDocumentTitle';

type Props = {
  title: string;
};

export function useAuthLayout(props: Props) {
  useDocumentTitle(props.title);
}
